import { render } from "./BookingScheduleTab.vue?vue&type=template&id=7753ff15"
import script from "./BookingScheduleTab.vue?vue&type=script&lang=js"
export * from "./BookingScheduleTab.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7753ff15"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7753ff15', script)) {
    api.reload('7753ff15', script)
  }
  
  module.hot.accept("./BookingScheduleTab.vue?vue&type=template&id=7753ff15", () => {
    api.rerender('7753ff15', render)
  })

}

script.__file = "src/components/BookingScheduleTab.vue"

export default script